module.exports = __webpack_public_path__ + "media/src/img/stamp-2465cba8efbb26925a0136a5b9f51f01.png";